import { render, staticRenderFns } from "./loseEfficacy.vue?vue&type=template&id=bf9b7a8e&scoped=true"
import script from "./loseEfficacy.vue?vue&type=script&lang=js"
export * from "./loseEfficacy.vue?vue&type=script&lang=js"
import style0 from "./loseEfficacy.vue?vue&type=style&index=0&id=bf9b7a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9b7a8e",
  null
  
)

export default component.exports